module.exports = __webpack_public_path__ + "img/RGB-logo-zeedhi-ED-powered.d5041ad3.png";